import { render, staticRenderFns } from "./FavoriteSvg.vue?vue&type=template&id=0bcbbc34&"
import script from "./FavoriteSvg.vue?vue&type=script&lang=js&"
export * from "./FavoriteSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports